module.exports = __webpack_public_path__ + "img/growthAbility8.f6cb8d09.png";